import { TransactionProps } from "../typings/transactions";

export const TRANSACTION_INITIAL_VALUES: TransactionProps = {
  from_account: 0,
  to_account: 0,
  date: null,
  comments: "",
  amount: 0,
  scholarship_application_id: 0,
};
